import { render, staticRenderFns } from "./AccessTrain.vue?vue&type=template&id=3be24aed&scoped=true"
import script from "./AccessTrain.vue?vue&type=script&lang=js"
export * from "./AccessTrain.vue?vue&type=script&lang=js"
import style0 from "./AccessTrain.vue?vue&type=style&index=0&id=3be24aed&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be24aed",
  null
  
)

export default component.exports